import { ActionIcon } from "@mantine/core";
import { CrossIcon } from "ui/icons";

export const CustomFieldRemoveButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <ActionIcon size="xs" color="green" radius="xl" variant="transparent" onClick={onClick}>
    <CrossIcon width={8} height={8} />
  </ActionIcon>
);
